<template>
    <div class="page-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">工单处理</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>研发人员工单</el-breadcrumb-item>
        </el-breadcrumb>
        <work />

    </div>
</template>

<script>
    import './api';
    import './store';
    import work from "./components/work";

    export default {
        name: 'DevelopUser',
        data() {
            return {};
        },
        components: {work},
        methods: {
            getUserName() {
                return null;
            },
            isDevelop() {
                return  true;
            },

        },
        created() {
        }
    };
</script>

<style lang="less" scoped>
</style>
